import { useState } from "react";
import MgmtMworksTab_position from "@components/feature/Account_management_mworks/MgmtMworksTab_position";
import MgmtMworksTab_member from "@components/feature/Account_management_mworks/MgmtMworksTab_member";
import MgmtMworksTab_division from "@components/feature/Account_management_mworks/MgmtMworksTab_division";
import { SubTab, SubTabItem } from "@/layouts/SubTab";

const TAB_ITEMS = [
  { id: 0, label: "직위 등록", component: <MgmtMworksTab_position /> },
  { id: 1, label: "부서 등록", component: <MgmtMworksTab_division /> },
  { id: 2, label: "직원 등록", component: <MgmtMworksTab_member /> },
];

export default function Account_management_mworks() {
  const [currentTab, setCurrentTab] = useState<number>(0);

  return (
    <div className="flex flex-col gap-10 max-w-[1400px] mx-auto pt-5 px-5">
      <SubTab aria-label="근무표 설정 탭">
        {TAB_ITEMS.map((tab) => (
          <SubTabItem
            key={tab.id}
            label={tab.label}
            value={tab.id}
            isActive={currentTab === tab.id}
            onSelect={() => setCurrentTab(tab.id)}
          />
        ))}
      </SubTab>
      <div className="overflow-auto">
        {TAB_ITEMS.map((tab) => tab.id === currentTab && tab.component)}
      </div>
    </div>
  );
}
